// extracted by mini-css-extract-plugin
export default {"br":"en","w80":"fn","card":"gn","wrapper":"hn","fullView":"in","profilePic":"jn","comment":"kn","animate":"ln","shimmer":"mn","square":"nn"};
    if(module.hot) {
      // 1715276855311
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  